import { Box, Grid2, Tab, Tabs } from "@mui/material";
import { Show } from "components/Show";
import DashboardLayout from "layouts/DashboardLayout";
import { useState } from "react";
import useDocumentTitle from "utils/useDocumentTitle";
import PrivateEquity from "./PrivateEquity";

const CompanyMasterDashboard = () => {
  useDocumentTitle("Company Master Dashboard");

  const [tabValue, setTabValue] = useState(0);

  const tabs = [
    {
      label: "Private Equity",
      component: (
        <PrivateEquity
          name={"privateEquity"}
          // tableName={"private_equity"}
          type={"PEQ"}
          routeKey={"FETCH_ALL_PRIVATE_EQUITY"}
          addBtnName={"Company"}
        />
      ),
    },
    {
      label: "Fixed Deposit",
      component: (
        <PrivateEquity
          name={"privateEquity"}
          // tableName={"private_equity"}
          type={"FD"}
          routeKey={"FETCH_ALL_PRIVATE_EQUITY"}
          addBtnName={"Bank"}
        />
      ),
    },
    {
      label: "AIF",
      component: (
        <PrivateEquity
          name={"AIF"}
          // tableName={"AIF"}
          type={"AIF"}
          routeKey={"FETCH_ALL_AIF"}
          addBtnName={"Company"}
        />
      ),
    },
  ];

  return (
    <DashboardLayout title="Other Assets">
      <Grid2 container spacing={2}>
        <Grid2 size={12}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              sx={{
                "& .MuiTabs-flexContainer": {
                  backgroundColor: "var(--white)",
                },
              }}
              onChange={(e, val) => setTabValue(val)}
              value={tabValue}
            >
              {tabs.map((tab, index) => (
                <Tab key={index} label={tab.label} disableRipple />
              ))}
            </Tabs>
          </Box>
        </Grid2>
        <Grid2 size={12}>
          {tabs.map((tab, index) => (
            <Show.When key={index} isTrue={tabValue === index}>
              {tab.component}
            </Show.When>
          ))}
        </Grid2>
      </Grid2>
    </DashboardLayout>
  );
};

export default CompanyMasterDashboard;
